// extracted by css-extract-rspack-plugin
export default {"icon":"footer-fragment__Icon_icon__Wj21E"};